"use strict";

import Event from './event';
import Config from '../config';
import * as Module from '../modules/';

export default class {

    constructor() {
        this.token = document.head.querySelector('meta[name="csrf-token"]').content;
        this.event = new Event();
        this.config = Config;
        this.countries = [];

        this.slick = new Module.Slick();
        this.header = new Module.Header();
        this.footer = new Module.Footer();
        this.magnificPopup = new Module.MagnificPopup();
        new Module.UsedCarsFilters();
        new Module.OwlCarusel();
        this.productFilter = new Module.ProductFilter();

        new Module.Spinner();
        new Module.AddToCart();
        new Module.AddToCartButton();
        new Module.CartModal();
        new Module.CartNumItems();
        new Module.CartHeader();
        new Module.Checkout();
        new Module.AddToMerkliste();
        new Module.Merkliste();
        new Module.AddToFavoriten();
        new Module.Favoriten();
        new Module.PasswordChange();
        new Module.Wirecard();
    }

    init(url) {
        this.url = url.replace(/\/+$/, "");

        // - Trigger cookie consent banner.
        cookieconsent.initialise(Config.cookieconsent);

        this.slick.init();
        this.header.init();
        this.magnificPopup.init();
        this.productFilter.init();

        new Module.ProductFilterForm();
        new Module.Register();
        new Module.Login();
        
        this.vue = new Vue({
            el: '#app'
        });

        // this.loadBrands();
        // this.loadKMs();
        // this.loadPrices();
        // this.loadGears();
        // this.loadFuels();
        // this.loadTypes();
        // this.loadYears();
        // this.loadLocations();
        // this.loadPower();
        // this.loadUsedCarFilters();

        this.cartData();
        this.fetchCountries();
        // this.merklisteData();
        // this.favoritenData();
    }

    loadUsedCarFilters() {
        new Form().post('/api/usedcarfilters')
            .then((response) => {
                this.event.fire('car.filters.loaded', response);
            });
    }

    loadBrands() {
        new Form().post('/api/brands')
            .then((response) => {
                this.event.fire('car.brands.loaded', response);
            });
    }

    loadKMs() {
        new Form().post('/api/kms')
            .then((response) => {
                this.event.fire('car.kms.loaded', response);
            });
    }

    loadPrices() {
        new Form().post('/api/prices')
            .then((response) => {
                this.event.fire('car.prices.loaded', response);
            });
    }

/*    loadGears() {
        new Form().post('/api/gears')
            .then((response) => {
                this.event.fire('car.gears.loaded', response);
            });
    }

    loadFuels() {
        new Form().post('/api/fuels')
            .then((response) => {
                this.event.fire('car.fuels.loaded', response);
            });
    }

    loadTypes() {
        new Form().post('/api/types')
            .then((response) => {
                this.event.fire('car.types.loaded', response);
            });
    }

    loadYears() {
        new Form().post('/api/years')
            .then((response) => {
                this.event.fire('car.years.loaded', response);
            });
    }

    loadLocations() {
        new Form().post('/api/locations')
            .then((response) => {
                this.event.fire('car.locations.loaded', response);
            });
    }*/

    loadPower() {
        new Form().post('/api/power')
            .then((response) => {
                this.event.fire('car.power.loaded', response);
            });
    }

    cartData() {
        new Form().get('/api/cart/content')
            .then((response) => {
                this.event.fire('cart.data.loaded', response);
            });
    }

    merklisteData() {
        new Form().get('/api/merkliste/content')
            .then((response) => {
                this.event.fire('merkliste.data.loaded', response);
            });
    }

    favoritenData() {
        new Form().get('/api/favoriten/content')
            .then((response) => {
                this.event.fire('favoriten.data.loaded', response);
            });
    }

    fetchCountries() {
        new Form().get('/register/countries')
            .then(countries => {
                this.countries = countries;
                this.event.fire('countries.loaded', countries);
            });
    }

}